export const LoyaltyLevelsTranslations = {
  'levels-1': 'loyalty-program.levels-1',
  'levels-2': 'loyalty-program.levels-2',
  'levels-3': 'loyalty-program.levels-3',
  'levels-4': 'loyalty-program.levels-4',
  'levels-5': 'loyalty-program.levels-5',
}
